const defaultAccess: string[] = [
  'Admin',
  'Chief',
  'Viewer',
  'Filters',
  'FilterViewer',
  'FilterChief',
  'FilterSupervisor',
];

export const FILTERS_ROLES_VIEWS_PERMISSIONS = {
  sharedActions: {
    schedulingTypeIdProduction: [
      ...defaultAccess,
      'FilterOperator',
      'FilterLeader',
      // Read-only scheduler access. Interactions (drag&drop, start/end WO,
      // edit operators, etc.) are blocked in FilterSchedulerAuthService.
      'FiltersQualityControl',
    ],
    schedulingTypeIdPacking: [
      ...defaultAccess,
      'FilterOperator',
      'FilterLeader',
      'FiltersQualityControl',
    ],
    validationTypeId: [
      ...defaultAccess,
      'FilterLeader',
      'FiltersQualityControl',
    ],
    packingBox: [
      'Admin',
      'Chief',
      'Viewer',
      'LabelOperator',
      'FiltersLabelOperator',
      'FilterSupervisor',
      'FilterChief',
      'FilterViewer',
      'FiltersQualityControl',
    ],
    performanceReportTypeId: [...defaultAccess, 'FilterLeader'],
    addInspectionSheets: [
      'Admin',
      'Chief',
      'Viewer',
      'QualityControl',
      'FiltersQualityControl',
    ],
    efficiency: [
      'Chief',
      'Admin',
      'FilterAdmin',
      'FilterChief',
      'FilterSupervisor', // Created
      'StandardsAdmin',
      'FilterStandardsAdmin', // Created
      'FilterEngineer', // created
    ],
    dailyPlanning: [
      'Chief',
      'Admin',
      'FilterAdmin',
      'FilterChief',
      'FilterSupervisor',
      'StandardsAdmin',
      'FilterStandardsAdmin',
      'FilterEngineer',
    ],
    qc: [
      ...defaultAccess,
      'TankOperator',
      'TankLeader',
      'FiltersQualityControl',
    ],
  },

  routerActions: {
    // No exclusivas del Router, todas están en el SideNav
  },

  sideNavActions: {
    reportsPbiFilters: [
      'Chief',
      'Admin',
      'Filters',
      'FilterChief',
      'FilterAdmin',
      'FilterViewer',
      'FilterOperator',
      'FilterLeader',
    ],
    root: [
      'Chief',
      'Admin',
      'Filters',
      'FilterChief',
      'FilterAdmin',
      'FilterViewer',
      'FilterOperator',
      'FilterLeader',
      'QualityControl',
      'FiltersQualityControl',
    ],
  },
};
